export const projects = [

  {
    title: "POS System",
    subtitle: "Java and My-Sql",
    description:
      "The Construction and Engineering POS (Point of Sale) Billing System is a specialized software solution tailored for businesses in the construction and engineering sectors. It streamlines billing processes, manages inventory, and offers efficient transaction management, efficiency and accuracy in financial transactions within the industry.",
    image: "./30.png",
    link: "https://youtu.be/2fgYoAyPUcE?si=_E8Hjc7FB7SDUTDr",
  },
  {
    title: "Movie Booking Site",
    subtitle: "Java and My-Sql",
    description:
      "A Fully Functional Movie Booking Website is an online platform that allows users to browse, select, and book movie tickets. It typically includes features like movie listings, showtimes, seat selection, and secure payment processing. Users can conveniently book movie tickets and enjoy a seamless cinema experience through this web-based service.",
    image: "./45.png",
    link: "https://youtu.be/u57VAUB3f9U?si=_FkQ69531rIesnP_",
  },
  {
    title: "Astrology Web-Site",
    subtitle: "JavaScript and My-Sql",
    description:
      "A Horizontal Scrolling Astrology Website is a unique web platform that presents astrological information and horoscopes in a horizontally scrolling format. Users can explore various astrological content, such as daily or monthly horoscopes, birth charts, and astrological insights, through the website's interactive and visually engaging design.",
    image: "./48.png",
    link: "https://youtu.be/eFJxO6jkVrE?si=1vU6NwqNHRZ6kWWp",
  },
  {
    title: "Donation Web-Site",
    subtitle: "C# and My-Sql",
    description:
      "The Blind Supporter Web Application is a digital platform designed to provide support and assistance to individuals with visual impairments. It offers features like voice-guided navigation, text-to-speech functionality, and accessibility tools to empower visually impaired users in accessing information,  support networks, their online experiences.",
    image: "./69.png",
    link: "https://youtu.be/VMrFU5u0EDQ?si=ejibuptFq6iBCYXm",
  },
  {
    title: "Delivery System",
    subtitle: "C# and My-Sql",
    description:
      "The Online Food Delivery System is an efficient platform that connects restaurants and customers, allowing users to order food online and have it delivered to their doorstep. This system streamlines the food ordering process and provides menus, and the  offers convenient payment options and the  enhancing the overall dining experience for customers.",
    image: "./68.png",
    link: "https://youtu.be/Lqom3Fejhuk?si=DlqGZH0MjI8NU6Un",
  },
  {
    title: "E-Commerce Site",
    subtitle: "PHP and My-Sql",
    description:
      "An E-Commerce Selling Website is a virtual marketplace where businesses can showcase and sell their products or services online. It offers a user-friendly interface for customers to browse, select, and purchase items with ease. These websites often include secure payment gateways ,shipping options, providing a convenient ,efficient shopping experience.",
    image: "./73.png",
    link: "https://youtu.be/up_38g5Axms?si=mI-KoodYW-LwCxLk",
  },
  {
    title: "Portfolio Site",
    subtitle: "React-Js and Mongo-Db",
    description:
      "A 3D Portfolio Web Application is a cutting-edge platform that allows users to showcase their work, skills, and accomplishments in a three-dimensional virtual environment. It offers an immersive and interactive experience, enabling visitors to navigate and explore the portfolio as if they were in a space.Engagement to traditional portfolio presentations.",
    image: "./77.png",
    link: "https://youtu.be/uj98U-oLDo0?si=Cy0lOLcblswvmHBB",
  },
  {
    title: "Game App",
    subtitle: "Flutter and Dart",
    description:
      "The Guessing Numbers Identification Mobile Application is a fun educational app that challenges users to identify numbers through various guessing games  activities. It's designed to enhance number recognition and cognitive skills in an engaging interactive way and the making it an ideal tool for early learning and numeracy development.",
    image: "./84.png",
    link: "https://youtu.be/aEWOxfS0s5U?si=oEPIcSgxU2EHK330",
  },
];

export const testimonials = [
  {
    quote:
    "I had the pleasure of collaborating with CodeShow LapZ on a challenging project, and I was consistently impressed by their problem-solving skills and attention to detail. Their ability to adapt to new technologies and learn quickly is a testament to their commitment to continuous improvement.",
    image: "https://www.fotolog.com/wp-content/uploads/2020/05/best-suits-for-men-featured-image-final-696x541.jpg",
    name: "Daude Akduvaza",
    company: "NSBM",
  },
  {
    quote:
    "I highly recommend CodeShow LapZ for their expertise in web development. Their proficiency in languages like JavaScript, Python, and Node.js, along with their commitment to best practices, ensures that they consistently deliver top-notch results.",
    image: "https://img.freepik.com/free-photo/young-successful-businessman-correcting-tie_176420-1133.jpg",
    name: "Rayan Macklem",
    company: "ICBT",
  },
  {
    quote:
    "I've had the privilege of mentoring CodeShow LapZ, and it's been incredible to witness their growth as a software engineer. Their passion for learning and dedication to mastering new technologies is truly inspiring.",
    image: "https://img.freepik.com/free-photo/young-successful-businessman-smiling-speaking-phone-black-background_176420-55697.jpg",
    name: "James Willson",
    company: "SLIIT",
  },
  {
    quote:
    "In addition to their technical skills, CodeShow LapZ is a pleasure to work with. Their positive attitude, willingness to collaborate, and problem-solving abilities make them a valuable asset to any organization.",
    image: "https://img.freepik.com/free-photo/portrait-handsome-bearded-stylish-male-wearing-elegant-suit-dark-background_613910-11359.jpg",
    name: "Jack Allison",
    company: "ESOFT",
  },
];

export const skills = [
  "Java",
  "Python",
  "JavaScript",
  "Flutter",
  "PHP",
  "C#",
  "C++",
  "React.js",
  "Next.js",
  "Node.js",
  "My-Sql",
  "Mongo-db",
];



// WEBPACK FOOTER //
// ./src/data.js